import * as React from 'react'
import { Divider, List } from '@mui/material'
import type { IUpwardForecastHistoryItem } from 'core/api/rest/queries/upward-forecast-history'
import HistoryListItem from './history-list-item'
import { uniqueId } from 'es-toolkit/compat'
import { useTranslation } from 'react-i18next'

interface IHistoryListProps {
  items: IUpwardForecastHistoryItem[]
}

const HistoryList: React.FunctionComponent<IHistoryListProps> = React.memo(({ items }) => {
  const { t } = useTranslation()
  const historySize = items?.length
  const exceptionsLastIndex = historySize ? historySize - 1 : null
  return historySize ? (
    <List>
      {items.map((item, index) => {
        const showDivider = index !== exceptionsLastIndex
        return (
          <React.Fragment key={`${item.activated}_${item.date}_${uniqueId()}`}>
            <HistoryListItem date={item.date} activated={item.activated} />
            {showDivider ? <Divider variant="inset" component="li" /> : null}
          </React.Fragment>
        )
      })}
    </List>
  ) : (
    <span>{t('upward_forecast.no_history')}</span>
  )
})

export default HistoryList
